import { Row } from "@tanstack/react-table"

interface ActiveDeletedFilterType {
  active?: "1" // If present, we want rows that are active (active === "1") and not deleted.
  disabled?: "1" // If present, we want rows that are disabled (active === "0")
  deleted?: "1" // If present, we want rows that are deleted (deleted === "1")
}

export const rowStatusFilter = <T extends { active: string; deleted?: string }>(
  row: Row<T>,
  columnId: string,
  filterValue: ActiveDeletedFilterType
): boolean => {
  const rowActive = row.original.active // Expected to be "1" or "0"
  const rowDeleted = row.original.deleted // Expected to be "1" if deleted, otherwise "0" or undefined

  // Build an array of conditions that must pass
  const conditions: boolean[] = []

  // If filtering for active rows is enabled, include that condition.
  if (filterValue.active) {
    // Active means row.active === "1" and not deleted (assume not deleted if rowDeleted is "0" or falsy)
    conditions.push(rowActive === "1" && (rowDeleted === "0" || !rowDeleted))
  }

  // If filtering for disabled rows is enabled, include that condition.
  if (filterValue.disabled) {
    conditions.push(rowActive === "0" && (rowDeleted === "0" || !rowDeleted))
  }

  // If filtering for deleted rows is enabled, include that condition.
  if (filterValue.deleted) {
    conditions.push(rowDeleted === "1")
  }

  // If at least one filter is set, return true if any condition is met.
  // If no filter is set, return true so that the row is not filtered out.
  return conditions.length ? conditions.some(condition => condition) : true
}
